import { memo } from 'react';

import { Flex, Stack, useTheme } from '@chakra-ui/react';

import { formatCurrency } from 'utils';

import { Text } from 'ui';

interface AccountBalanceProps {
  isMobile: boolean;
  balance: number;
}
const AccountBalance = ({ isMobile, balance = 0 }: AccountBalanceProps) => {
  const {
    colors: {
      palette: {
        components: {
          profileSidebar: { accountBalance: styles }
        }
      }
    }
  } = useTheme();

  return balance > 0 ? (
    <Stack
      cursor='default'
      gap={0}
      mt={isMobile ? 0 : '15px'}
      bg={isMobile ? styles.titleBg : styles.amountBg}
      overflow='hidden'
      alignItems='center'
      borderRadius={isMobile ? 0 : '3px'}
      py={isMobile ? '10px' : 0}
      minH={isMobile ? '50px' : 'auto'}
      justifyContent='center'
    >
      <Flex
        display={isMobile ? 'none' : 'flex'}
        py='4px'
        justifyContent='center'
        alignItems='center'
        bg={styles.titleBg}
        paddingX={{ base: isMobile ? 0 : '14px', lg: '17px' }}
        w='100%'
      >
        <Text
          fontSize='12px'
          textTransform='uppercase'
          color={styles.titleColor}
        >
          Account Balance
        </Text>
      </Flex>
      <Flex
        alignItems='center'
        justifyContent='center'
        pl={{ base: isMobile ? 0 : '14px', lg: '17px' }}
        pr={{ base: isMobile ? 0 : '14px', lg: '12px' }}
        py={isMobile ? 0 : '16px'}
        gap='5px'
        w='100%'
      >
        <Stack
          flexDirection='row'
          justifyContent='center'
          flexWrap={{ base: 'wrap', sm: 'nowrap' }}
          alignItems='center'
          px={{ base: '50px', sm: '0' }}
          gap={{ base: '6px', md: '13px' }}
          flex={1}
        >
          <Text
            display={isMobile ? 'block' : 'none'}
            fontSize='12px'
            textTransform='uppercase'
            textAlign='center'
            lineHeight='10px'
            pt={{ base: '4px', lg: 0 }}
            color={styles.titleColor}
          >
            Account Balance
          </Text>

          <Text
            as='span'
            fontSize={{ base: '18px', lg: '22px' }}
            fontWeight='semibold'
            textAlign='center'
            color={isMobile ? styles.titleColor : styles.amountColor}
          >
            {formatCurrency(balance)}
          </Text>
        </Stack>
      </Flex>
    </Stack>
  ) : null;
};

export default memo(AccountBalance);
